import { Injectable, inject } from '@angular/core';
import {
  CoreRouterActionGoBack,
  CoreRouterActionNavigateForward,
  CoreRouterActions
} from '@bepatient/core';
import { EventsActionTypes } from '@bepatient/events-store';
import { ToastController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

@Injectable()
export class EventsEffects {
  private store = inject<Store<any>>(Store);
  private actions$ = inject(Actions);
  private toastController = inject(ToastController);
  private translate = inject(TranslateService);

  saveEventSuccess$: Observable<CoreRouterActionGoBack> = createEffect(() =>
    this.actions$.pipe(
      ofType(EventsActionTypes.SAVE_EVENT_SUCCESS),
      tap(() => {
        this.toastController
          .create({
            message: this.translate.instant(
              'EVENTS.MESSAGES.SAVE_EVENT_SUCCESS'
            ),
            position: 'top',
            duration: 2000,
            cssClass: 'bepatient_dynamic_form_save_toast'
          })
          .then(toast => toast.present());
      }),
      map(() => new CoreRouterActionGoBack())
    )
  );

  selectEvent$: Observable<CoreRouterActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(EventsActionTypes.SELECT_EVENT),
      map(
        () =>
          new CoreRouterActionNavigateForward({
            url: '/update-event'
          })
      )
    )
  );

  deleteEvent$: Observable<CoreRouterActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(EventsActionTypes.DELETE_EVENT_SUCCESS),
      tap(() => {
        this.toastController
          .create({
            message: this.translate.instant(
              'EVENTS.MESSAGES.DELETE_EVENT_SUCCESS'
            ),
            position: 'top',
            duration: 2000,
            cssClass: 'bepatient_dynamic_form_save_toast'
          })
          .then(toast => toast.present());
      }),
      map(() => new CoreRouterActionGoBack())
    )
  );

  updateEvent$: Observable<CoreRouterActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(EventsActionTypes.UPDATE_EVENT_SUCCESS),
      tap(() => {
        this.toastController
          .create({
            message: this.translate.instant(
              'EVENTS.MESSAGES.UPDATE_EVENT_SUCCESS'
            ),
            position: 'top',
            duration: 2000,
            cssClass: 'bepatient_dynamic_form_save_toast'
          })
          .then(toast => toast.present());
      }),
      map(() => new CoreRouterActionGoBack())
    )
  );
}
